import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import Button from '@/shared/components/buttons/Button.vue';
import FormFieldInput from '@/shared/components/form/FormFieldInput.vue';

/* STATE */
/**
 * Distance is given in meters
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckDistanceSidebar',
  emits: ["update:distance", "close"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:distance', distance: number): number;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const distance = ref<number>(200);

/* EMITS */


function updateDistance(value: number): void {
  distance.value = value ?? 0;
  emit('update:distance', distance.value);
}

return { __sfc: true,distance, emit, updateDistance, Button, FormFieldInput }
}

})